import Link from "next/link"
import "@/styles/error.scss"

interface ErrorContainerProps {
    error?: Error | { digest?: string; message?: string }
}

export function ErrorContainer({ error }: ErrorContainerProps) {
    return (
        <div className="content-container">
            {error ? (
                error.message == "Wrong facility code" ? (
                    <>
                        <div className="message-wrapper">
                            <h2>
                                施設コードが間違っているか、
                                <br />
                                アンケート回答期限を過ぎています
                                <br />
                                正しい施設コードをご入力ください
                            </h2>
                            <p>TOPへ戻って最初からやりなおしてください</p>
                            <p>
                                <Link href={"/"}>TOPへ</Link>
                            </p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="message-wrapper">
                            <h2>{error.message}</h2>
                            <p>TOPへ戻って最初からやりなおしてください</p>
                            <p>
                                <Link href={"/"}>TOPへ</Link>
                            </p>
                        </div>
                    </>
                )
            ) : (
                <>
                    <div className="message-wrapper">
                        <h2>エラーが発生しました</h2>
                        <p>TOPへ戻って最初からやりなおしてください</p>
                        <p>
                            <Link href={"/"}>TOPへ</Link>
                        </p>
                    </div>
                </>
            )}
        </div>
    )
}
